<template>
  <div class="bto-sb-history-content" v-show="isOpened || type === 'checker'" @click.stop>
    <empty-state
      v-if="!betDetails.items"
      :message="emptyStateStatusMessage"
      :icon-class="emptyStateClass" />
    <div
      v-for="(event, i) in betDetails.items"
      :key="i"
      :class="[
        'bto-sb-history-item',
        {
          'bto-sb-item-won': checkEventStatus(event, WON),
          'bto-sb-item-open': !isEventLive(event) && checkEventStatus(event, PLACED),
          'bto-sb-item-inplay': isEventLive(event) && checkEventStatus(event, PLACED),
          'bto-sb-item-lost': checkEventStatus(event, LOST),
          'bto-sb-item-suspended': false,
        },
      ]">
      <div
        :class="['bto-sb-history-item-title', { 'bto-sb-history-banker': event.banker }]"
        v-if="checkMatchType(event, BET_BUILDER) || checkMatchType(event, BOOSTED_ODD) || checkMatchType(event, ALGO)">
        <span class="bto-sb-history-type">{{ checkMatchType(event, BOOSTED_ODD) ? t(event.type) : generateMatchTitle(event) }}</span>
        <span class="bto-sb-history-odd">
          {{ parseFloat(event.odd) | formatOddDisplay($root.oddFormat) }}
        </span>
      </div>
      <div :class="['bto-sb-history-item-title', { 'bto-sb-history-banker': event.banker }]" v-else>
        <span class="bto-sb-history-type">{{ getLatamOutcomeName(event) }}</span>
        <span class="bto-sb-history-odd">
          {{ parseFloat(event.odd) | formatOddDisplay($root.oddFormat) }}
        </span>
      </div>
      <template v-if="checkMatchType(event, BET_BUILDER) || checkMatchType(event, ALGO)">
        <div class="bto-sb-history-item-info">
          <span class="bto-sb-history-event">
            {{ event.sportName }} - {{ event.tournamentName }}
          </span>
          <span
            :class="[
              getEventStatusClass(event),
              'bto-sb-history-event-status',
              { 'bto-sb-history-event-marketlive': isEventLive(event) },
            ]">
            {{ generateEventStatusText(event) }}
          </span>
          <div
            class="bto-sb-history-item-markets"
            v-for="(market, idx) in getBetBuilderMarkets(event)"
            :key="idx">
            <span class="bto-sb-history-event-market" v-if="market[0]">{{ market[0] }}</span>
            <span class="bto-sb-history-event-market-info" v-if="market[1]">{{ market[1] }}</span>
          </div>
        </div>
      </template>
      <div class="bto-sb-history-item-info" v-else>
        <span class="bto-sb-history-event-market">
          {{ event.market }}<span class="bto-sb-cashback" v-if="event.cashoutAvailable"></span>
        </span>
        <span class="bto-sb-history-event">
          <span class="bto-sb-history-event-result">{{ event.score }}</span>
          {{ generateMatchTitle(event) }}
        </span>
        <span
          :class="[
            getEventStatusClass(event),
            'bto-sb-history-event-status',
            { 'bto-sb-history-event-marketlive': isEventLive(event) },
          ]">
          {{ generateEventStatusText(event) }}
        </span>
      </div>
    </div>
    <div class="bto-sb-history-stake">
      <div
        class="bto-sb-history-item"
        v-for="(comb, index) in betDetails.combinations"
        :key="index">
        <div class="bto-sb-history-stakeinfo">
          <span class="bto-sb-history-stake-title">{{ generateCombinationTitleText(comb) }}</span>
          <span class="bto-sb-history-stake-total">
            {{ comb.stake | formatAmountDisplay(betDetails.currencyCode) }}
          </span>
        </div>
        <div class="bto-sb-history-stakeinfo" v-if="comb.bonus > 0">
          <span class="bto-sb-history-stake-title">{{ t("Mobile.Bonus") }}</span>
          <span class="bto-sb-history-stake-total">
            {{ comb.bonus | formatAmountDisplay(betDetails.currencyCode) }}
          </span>
        </div>
        <div class="bto-sb-history-stakeinfo" v-if="comb.tax">
          <span class="bto-sb-history-stake-title">{{ t("Mobile.Tax") }}</span>
          <span class="bto-sb-history-stake-total">
            {{ comb.tax | formatAmountDisplay(betDetails.currencyCode) }}
          </span>
        </div>
        <div
          class="bto-sb-history-stakeinfo bto-sb-history-stake-win"
          v-if="showCombStakeWinText(comb)">
          <span class="bto-sb-history-stake-title">{{ generateCombStakeWinText(comb) }}</span>
          <span class="bto-sb-history-stake-total">
            {{ (comb.winnings || comb.potWinnings) | formatAmountDisplay(betDetails.currencyCode) }}
          </span>
        </div>
      </div>
      <div class="bto-sb-history-item">
        <div class="bto-sb-history-stakeinfo" v-if="parseFloat(betDetails.odds)">
          <span class="bto-sb-history-stake-title">{{ t("Mobile.Odds") }}</span>
          <span class="bto-sb-history-stake-total">
            {{ betDetails.odds | formatOddDisplay($root.oddFormat) }}
          </span>
        </div>
        <div class="bto-sb-history-stakeinfo">
          <span class="bto-sb-history-stake-title">{{ t("Mobile.totalStake") }}</span>
          <span class="bto-sb-history-stake-total">
            {{ betDetails.stake | formatAmountDisplay(betDetails.currencyCode) }}
          </span>
        </div>
        <div class="bto-sb-history-stakeinfo" v-if="betDetails.bonus > 0">
          <span class="bto-sb-history-stake-title">{{ t("Mobile.Bonus") }}</span>
          <span class="bto-sb-history-stake-total">
            {{ betDetails.bonus | formatAmountDisplay(betDetails.currencyCode) }}
          </span>
        </div>
        <div class="bto-sb-history-stakeinfo bto-sb-history-stake-win" v-if="betDetails.tax">
          <span class="bto-sb-history-stake-title">{{ t("Mobile.Tax") }}</span>
          <span class="bto-sb-history-stake-total">
            {{ betDetails.tax | formatAmountDisplay(betDetails.currencyCode) }}
          </span>
        </div>
        <div class="bto-sb-history-stakeinfo bto-sb-history-stake-win" v-if="showStakeWinText">
          <span class="bto-sb-history-stake-title">{{ generateStakeWinText }}</span>
          <span class="bto-sb-history-stake-total">
            {{
              (betDetails.winnings || betDetails.potWinnings)
                | formatAmountDisplay(betDetails.currencyCode)
            }}
          </span>
        </div>
      </div>
      <div class="bto-sb-history-totalstake" v-if="isNegotiation">
        <span>
          <i>{{ t("Mobile.totalStake") }}</i>
          <i>
            <strong>{{ betDetails.stake | formatAmountDisplay(betDetails.currencyCode) }}</strong>
          </i>
        </span>
        <span>
          <i>{{ t("Mobile.Total") }} {{ t("Mobile.PossibleWinnings") }}</i>
          <i>
            {{
              (betDetails.winnings || betDetails.potWinnings)
                | formatAmountDisplay(betDetails.currencyCode)
            }}
          </i>
        </span>
      </div>
      <div class="bto-sb-history-footer" v-if="isNegotiation">
        <a class="bto-sb-form-btn bto-sb-btn-accept" @click.stop="acceptNegotiation(betDetails)">
          {{ t("Mobile.AcceptChanges") }}
        </a>
        <a class="bto-sb-form-btn bto-sb-btn-discard" @click.stop="rejectNegotiation(betDetails)">
          {{ t("W.DiscardBet") }}
        </a>
      </div>
    </div>
    <MyBetsInlineFooter :betDetails="betDetails" v-if="!isNegotiation" />
  </div>
</template>

<script>
  import base from './base';
  import store from '../../../../store/index';
  import { getLatamOutcomeName } from '@/services/mybets/outcome-translation-service';
  import MyBetsInlineFooter from '../mybet-details-footer/my-bets-inline-footer';
  import {
    MYBETS_SHOW_WON_STATUSES,
    MYBETS_SHOW_WINNINGS_STATUSES,
    MYBETS_STATUS_MOBILE_TEXT,
    MYBETS_STATUS_HISTORY_CLASS
  } from '../../../../models/enums/mybets-const';
  import { EmptyState, ICON_CLASS } from '../../empty-state';
  import { formatCurrency } from '@bto-services/utils';
  import { checkLayout } from "bto-models/app-settings/web";

  export default {
    name: 'MyBetsInlineDetails',
    extends: base,
    components: {
      MyBetsInlineFooter,
      EmptyState,
    },
    data() {
      return {
        emptyStateIcon: ICON_CLASS.MYBETS,
        loadingSpinner: ICON_CLASS.LOADING,
        IS_US_LAYOUT: checkLayout('US'),
      };
    },
    props: {
      isOpened: {
        type: Boolean,
        default: false,
      },
      isLoading: {
        type: Boolean,
        default: true,
      },
      isNegotiation: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        required: false,
      }
    },
    computed: {
      generateStakeWinText() {
        if (this.checkGroupStatus(this.PLACED)) {
          return this.$translate.text('Mobile.PossibleWinnings');
        }
        if (MYBETS_SHOW_WON_STATUSES.some(status => this.checkGroupStatus(status))) {
          return this.$translate.text('M.Returned');
        }
        if (this.checkGroupStatus(this.CASHED_OUT)) {
          return this.$translate.text('Mobile.CachedOut');
        }

        return '';
      },
      showStakeWinText() {
        return MYBETS_SHOW_WINNINGS_STATUSES.some(status => this.checkGroupStatus(status));
      },
      emptyStateClass() {
        return this.isLoading ? this.loadingSpinner : this.emptyStateIcon;
      },
      emptyStateStatusMessage() {
        return this.isLoading ? this.t('Mobile.LoadingMore') : this.t('M.MyBetsEmpty');
      },
    },
    methods: {
      generateEventStatusText(event) {
        if (MYBETS_STATUS_MOBILE_TEXT[event.itemStatusId] && !this.checkEventStatus(event, this.PLACED)) {
          return this.$translate.text(MYBETS_STATUS_MOBILE_TEXT[event.itemStatusId].status);
        } else if (this.isEventLive(event)) {
          return event.scoreTime || '';
        } else if (this.checkEventStatus(event, this.PLACED)) {
          return `${event.eventDateString}`;
        }
      },
      getEventStatusClass(event) {
        return MYBETS_STATUS_HISTORY_CLASS[event.itemStatusId] || '';
      },
      generateCombStakeWinText(comb) {
        if (this.checkCombStatus(comb, this.PLACED)) {
          return this.$translate.text('Mobile.PossibleWinnings');
        }
        if (MYBETS_SHOW_WON_STATUSES.some(status => this.checkCombStatus(comb, status))) {
          return this.$translate.text('M.Returned');
        }
        if (this.checkCombStatus(comb, this.CASHED_OUT)) {
          return this.$translate.text('Mobile.CachedOut');
        }

        return '';
      },
      generateCombinationTitleText(comb) {
        const translatedBetType = this.$translate.text(comb.betType);
        return `${comb.numOfBets} x ${formatCurrency(comb.unitStake, this.betDetails.currencyCode)} ${translatedBetType}`;
      },
      showCombStakeWinText(comb) {
        return MYBETS_SHOW_WINNINGS_STATUSES.some(status => this.checkCombStatus(comb, status));
      },
      generateMatchTitle(match) {
        if (match.isUS && this.IS_US_LAYOUT && match.guestTeam && match.homeTeam) {
          return `${match.guestTeam} @ ${match.homeTeam}`;
        }

        return match.matchTitle;
      },
      rejectNegotiation({ betSlipGroupID }) {
        store.dispatch('processOffer', { isAccepted: false, betSlipGroupID, clicked: true });
      },
      acceptNegotiation({ betSlipGroupID }) {
        store.dispatch('processOffer', { isAccepted: true, betSlipGroupID, clicked: true });
      },
      getBetBuilderMarkets(event) {
        if ((!this.checkMatchType(event, this.BET_BUILDER) && !this.checkMatchType(event, this.ALGO)) || !event.market) {
          return [];
        }
        const markets = event.market.split(',');
        return markets.map(m => m.split(' - '));
      },

      getLatamOutcomeName,
    },
  };
</script>